import type { TileableModel, TileViewModel } from '../view-models/tile';

/**
 * Aspect ratio configuration mapping aspect ratio keys to Tailwind CSS classes.
 * These classes correspond to custom aspect-ratio utilities defined in tailwind.config.js.
 */
const ASPECT_RATIO_CLASS_MAP: Record<string, string> = {
    /** Featured tiles take all available space in the grid without a fixed aspect ratio. */
    featured: 'h-full',
    default: 'aspect-tile-default',
    article: 'aspect-tile-article',
    category: 'aspect-tile-category',
    square: 'aspect-square',
};

const DEFAULT_ASPECT_RATIO = 'default';
const DEFAULT_CLASS = 'aspect-tile-default';

/**
 * Maps an aspect ratio key to the corresponding Tailwind CSS class.
 * Used by StaticTile, WebsiteTile, and other simple tile components that need
 * aspect ratio styling without the full TileMedia component.
 *
 * @param aspectRatio - The aspect ratio key from TileViewModel
 * @returns The corresponding Tailwind CSS class string
 */
export const getAspectRatioClass = (
    aspectRatio: TileViewModel<TileableModel>['aspectRatio']
): string => {
    const key = aspectRatio ?? DEFAULT_ASPECT_RATIO;
    const className = ASPECT_RATIO_CLASS_MAP[key];
    return className ?? DEFAULT_CLASS;
};
